export default function About() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Sobre a BitFlow - Fundo branco limpo */}
      <section id="about" className="py-24 bg-white relative overflow-hidden">
        {/* Glow verde sutil no canto superior direito */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#72BF3B]/[0.04] rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-gray-500 text-sm font-mono mb-4">/sobre a BitFlow</p>
              <h2 className="text-5xl font-bold text-[#162840] mb-6 leading-tight">
                Parceiro estratégico em <span className="text-[#72BF3B]">transformação digital</span>
              </h2>
              
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                A <strong>BitFlow</strong> é uma empresa especializada em transformação digital, automação de processos e soluções tecnológicas, ajudando negócios a organizarem melhor suas rotinas, aumentarem a produtividade e evoluírem com mais eficiência.
              </p>

              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Nosso foco é criar um verdadeiro flow operacional, integrando tecnologia ao dia a dia das equipes para que processos se tornem mais simples, conectados e automatizados.
              </p>

              <button 
                onClick={() => scrollToSection('contact')}
                className="hidden lg:inline-block bg-[#72BF3B] text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-[#99D93B] transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Conhecer Soluções
              </button>
            </div>

            {/* Card azul - oculto no mobile */}
            <div className="relative hidden lg:block">
              <div className="bg-gradient-to-br from-[#162840] to-[#1A2F4F] p-12 rounded-3xl text-white shadow-2xl">
                <div className="space-y-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#72BF3B] rounded-xl flex-shrink-0">
                      <i className="ri-lightbulb-flash-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-[#72BF3B]">Inovação</h3>
                      <p className="text-white/80 leading-relaxed">Soluções tecnológicas modernas e personalizadas para cada negócio</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#72BF3B] rounded-xl flex-shrink-0">
                      <i className="ri-team-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-[#72BF3B]">Parceria</h3>
                      <p className="text-white/80 leading-relaxed">Trabalhamos lado a lado com nossos clientes para garantir resultados</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#72BF3B] rounded-xl flex-shrink-0">
                      <i className="ri-rocket-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-[#72BF3B]">Crescimento</h3>
                      <p className="text-white/80 leading-relaxed">Foco em resultados reais e evolução contínua do seu negócio</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#72BF3B] rounded-xl flex-shrink-0">
                      <i className="ri-settings-3-line text-2xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-[#72BF3B]">Eficiência</h3>
                      <p className="text-white/80 leading-relaxed">Processos otimizados e automatizados para máxima produtividade</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Parceiro Bitrix24 - Fundo off-white limpo */}
      <section id="bitrix" className="py-24 bg-[#FAFBFC] relative overflow-hidden">
        {/* Glow verde sutil no canto inferior esquerdo */}
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#72BF3B]/[0.04] rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none"></div>
        
        {/* Linha separadora sutil no topo */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-[#72BF3B]/30 to-transparent"></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-gray-500 text-sm font-mono mb-4">/parceiro oficial Bitrix24</p>
              <h2 className="text-4xl font-bold text-[#162840] mb-6">
                A plataforma completa para <span className="text-[#72BF3B]">gestão do seu negócio</span>
              </h2>
              
              <img 
                src="https://static.readdy.ai/image/5db6c70661e6539a4f8850e6261ec391/c438a47ff4f0d30f8bf0cebe573679c6.png" 
                alt="Bitrix24 Logo"
                className="w-56 mb-6"
              />
              
              <p className="text-lg text-gray-600 leading-relaxed mb-4">
                O <strong>Bitrix24</strong> é uma plataforma all-in-one utilizada por mais de <strong>15 milhões de organizações</strong> em todo o mundo, reunindo CRM, gestão de projetos, comunicação interna, automação de processos e muito mais.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed">
                Como <strong>parceiro oficial</strong>, a BitFlow garante que sua empresa aproveite ao máximo todas as funcionalidades disponíveis, com implementação personalizada e suporte dedicado.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white p-5 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/20 transition-all cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-3">
                  <i className="ri-customer-service-2-line text-xl text-[#72BF3B]"></i>
                </div>
                <h4 className="font-semibold text-[#162840] mb-1">CRM Completo</h4>
                <p className="text-xs text-gray-600">Gestão de leads e automação de vendas</p>
              </div>

              <div className="bg-white p-5 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/20 transition-all cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-3">
                  <i className="ri-chat-3-line text-xl text-[#72BF3B]"></i>
                </div>
                <h4 className="font-semibold text-[#162840] mb-1">Comunicação</h4>
                <p className="text-xs text-gray-600">Chat, videochamadas e colaboração</p>
              </div>

              <div className="bg-white p-5 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/20 transition-all cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-3">
                  <i className="ri-task-line text-xl text-[#72BF3B]"></i>
                </div>
                <h4 className="font-semibold text-[#162840] mb-1">Gestão de Projetos</h4>
                <p className="text-xs text-gray-600">Kanban, Gantt e monitoramento</p>
              </div>

              <div className="bg-white p-5 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/20 transition-all cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-3">
                  <i className="ri-robot-2-line text-xl text-[#72BF3B]"></i>
                </div>
                <h4 className="font-semibold text-[#162840] mb-1">Automação e IA</h4>
                <p className="text-xs text-gray-600">CoPilot AI e fluxos automáticos</p>
              </div>

              <div className="bg-white p-5 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/20 transition-all cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-3">
                  <i className="ri-global-line text-xl text-[#72BF3B]"></i>
                </div>
                <h4 className="font-semibold text-[#162840] mb-1">Sites e E-commerce</h4>
                <p className="text-xs text-gray-600">Lojas integradas ao CRM</p>
              </div>

              <div className="bg-white p-5 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/20 transition-all cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-3">
                  <i className="ri-links-line text-xl text-[#72BF3B]"></i>
                </div>
                <h4 className="font-semibold text-[#162840] mb-1">Integrações</h4>
                <p className="text-xs text-gray-600">WhatsApp, e-mail e mais</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
